import React, { useState } from "react";
import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  ListItemText,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { useStateValue } from "../../Hooks/stateProvider";
import { useLocation } from "react-router";
import { ls } from "../../variables";
import { useNavigate } from "react-router-dom";
import Styles from "./Styles/moduleLayout.module.css";
import UploadAction from "./UploadAction";
import { encrypt } from "../../utils/cipher";
//import EditFile from "./EditFile";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { LightTooltip } from "../../components/LightTooltip";
import { actionsOptions } from "../../variables";
import { getDate } from "../../utils/getDate";
import { errorHandler } from "../../utils/errorHandling";

const CommentDialogBox = ({
  userType,
  open,
  setOpen,
  fetchData,
  selectedInstID,
  onClose,
  statusPending,
  remarks,
  trackerPageFetch,
}) => {


  const [pmsComments, setPmsComments] = useState("");
  const [proposedAction, setProposedAction] = useState("");
  const [selectedActions, setSelectedActions] = useState([]);
  const location = useLocation();
  const [
    {
      PMSTrackerData,
      PMSTrackerPageData,
      SEBITrackerData,
      SEBITrackerPageData,
      moduleType,
      fileName,
      fileDetails,
      pmsName,
      CMMTrackerPageData,
      fy_year,
      quarter
    },
    dispatch,
  ] = useStateValue();
  const [sebiComments, setSebiComments] = useState("");
  const [submit, setSubmit] = useState(false);
  const [deleteFlag, setDeleteFlag] = useState("");
  const [file, setFile] = useState(fileName);
  const [Details, setDetails] = useState(fileDetails);
 
  const handleFile = () => {
    setFile("")
    setDetails();

  }

  const navigate = useNavigate();


  const handleActionsChange = (val) => {
    if (selectedActions.includes(val)) {
      setSelectedActions(selectedActions.filter(selectedId => selectedId !== val));
    } else {
      setSelectedActions([...selectedActions, val]);
    }
  };

  const handleDeleteFile = () => {
    setDeleteFlag("delete");
  }


  const handleSubmit = async (receivedStatus) => {
    const date = getDate();
    const formData = new FormData();
    let payload;
    const pmsname = ls.get("pmsName");
    let status = (receivedStatus == true) ? "closed" : "open";
    let sebi_remarks = [];
    if (selectedActions.length > 0 && receivedStatus == true) {
      sebi_remarks = selectedActions;
    }
    if (userType == "PMS") {
      if (moduleType == "ALERT") {
        payload = {
          fy_year: PMSTrackerData.fy_year,
          quarter: PMSTrackerData.quarter,
          pmsName: pmsname,
          ticketid: PMSTrackerPageData.ticketID,
          guidancetype: PMSTrackerPageData.guidanceType,
          instanceid: PMSTrackerPageData.instanceID,
          // noofinstances: selectedInstID.length,
          status: PMSTrackerPageData.pmsTrackerViewStatus == "pending" ? "pending" : 'open (sebi)',
          moduleType: moduleType,
          userType: userType,
          alertNo: selectedInstID,
          deleteFlag: deleteFlag,
          instanceCount: PMSTrackerPageData.instanceCount - PMSTrackerPageData.caseIdCount,
          remarks: {
            pmscomments: pmsComments,
            proposedplanofaction: proposedAction,
            date: date,
            status: PMSTrackerPageData.pmsTrackerViewStatus == "pending" ? "pending" : 'open (sebi)',
          }
          // month:monthName,
          // year:year
        }
      }
      else {
        payload = {
          fy_year: CMMTrackerPageData.fy_year,
          quarter: CMMTrackerPageData.quarter,
          pmsName: pmsname,
          cmm_id: [CMMTrackerPageData.cmm_id],
          guidancetype: CMMTrackerPageData.guidanceType,
          instanceid: CMMTrackerPageData.instanceID,
          status: 'open (sebi)',
          moduleType: moduleType,
          userType: userType,
          deleteFlag: deleteFlag,
          remarks: {
            pms_comments: pmsComments,
            date: date,
            status: "open (sebi)"
          }
        }
      }
    }
      else {
        if (moduleType == "ALERT") {
          payload = {
            fy_year: SEBITrackerData.fy_year,
            quarter: SEBITrackerData.quarter,
            pmsName: pmsname,
            ticketid: SEBITrackerPageData.ticketID,
            guidancetype: SEBITrackerPageData.guidanceType,
            instanceid: SEBITrackerPageData.instanceID,
            //noofinstances: selectedInstID.length,
            remarks: {
              sebicomments: sebiComments,
              date: date,
              status: status == 'open' ? 'open' : status,
            },
            sebi_remarks: sebi_remarks,
            status: status == 'open' ? 'open' : status,
            moduleType: moduleType,
            // moduleType: ls.get("moduleType"),
            userType: userType,
            alertNo: selectedInstID,

          };
        }
        else {
          payload = {
            fy_year: SEBITrackerData.fy_year,
            quarter: SEBITrackerData.quarter,
            pmsName: pmsName,
            cmm_id: SEBITrackerPageData.id,
            remarks: {
              sebi_comments: sebiComments,
              date: date,

              // proposedplanofaction: proposedAction
            },
            sebi_remarks: sebi_remarks,
            status: status == 'open' ? 'open' : status,
            // moduleType: ls.get("type"),
            moduleType: moduleType.toUpperCase(),
            userType: userType,
            alertNo: selectedInstID,

          };
        }
      }
      const encryptedFormData = await encrypt(payload)

      if (moduleType == "ALERT" && statusPending == "pending") {
        formData.append("file", Details);
        formData.append("fileName", file);
      } else {
        formData.append("file", fileDetails);
        formData.append("fileName", fileName);
      }
      formData.append("payload", encryptedFormData);

      const encryptedHeaders = await encrypt({
        authtoken: ls.get("authToken"),
        refreshToken: ls.get("refreshToken")
      })

      dispatch({ type: "SHOW_LOADER" });
      axios
        .post("/api/pms/settlementUpload", formData, {
          withCredentials: true,
          headers: {
            headers: encryptedHeaders
          }
        })
        .then((data) => {
          dispatch({ type: "HIDE_LOADER" });
          dispatch({ type: "fileName", fileName: "" })
          dispatch({ type: "fileDetails", fileDetails: Details })
          if (fetchData) fetchData();
          if (trackerPageFetch) trackerPageFetch();

          //onClose();
          // receivedStatus && navigate(-1)
        })
        .catch((err) => {
          console.log("err value", err)
          dispatch({ type: "HIDE_LOADER" });
          errorHandler(err, navigate)
        })
    };


    // useEffect(()=>{

    // if(moduleType=="ALERT" && statusPending=="pending" && remarks[0].s3Location){
    //   console.log("details>>",moduleType)
    //           dispatch({ type: "fileName", fileName:remarks[0].uploadedfileName })
    // }else{
    //   dispatch({ type: "fileName", fileName:"" })
    // }
    // },[])

    const handleSelectAll = (e) => {
      if (selectedActions.length === actionsOptions.length) {
        setSelectedActions([]);
      }
      else {
        let options = actionsOptions.map(val => val.value);
        setSelectedActions(options);
      }
    };

    const handleClose = () => {
      setOpen(false);
    };
    return (
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          component: "form",
          onSubmit: (event) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries(formData.entries());
            const email = formJson.email;
            // handleClose();
          },
        }}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            // width: "30rem",
          }}
        >
          <div>Comment</div>
          <div className={Styles.crossBtn} onClick={handleClose}>
            <CloseIcon />
          </div>
        </DialogTitle>
        <DialogContent>
          {userType == "PMS"? (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h4 style={{ width: "30%" }}>{userType} Comments</h4>
                <TextField
                  autoFocus
                  required
                  // margin="dense"
                  id="pmsComments"
                  name="pmsComments"
                  defaultValue={(moduleType == "ALERT" && statusPending == "pending") ? `${remarks[0].pmscomments}` : ""}
                  placeholder={`${userType}` + " Comments"}
                  type="text"
                  fullWidth
                  variant="outlined"
                  multiline
                  sx={{ backgroundColor: "#EAEAEA" }}
                  onChange={(event) => {
                    setPmsComments(event.target.value);
                  }}
                />
              </div>
              {(moduleType == "ALERT") &&
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <h4 style={{ width: "30%" }}>Proposed Plan of Action</h4>
                  <TextField
                    autoFocus
                    required
                    // margin="dense"
                    id="ppa"
                    name="ppa"
                    //  label="Proposed Plan of Actions"
                    defaultValue={(moduleType == "ALERT" && statusPending == "pending") ? `${remarks[0].proposedplanofaction}` : ""}
                    type="text"
                    fullWidth
                    placeholder={"Proposed Plan Of Action"}
                    variant="outlined"
                    multiline
                    sx={{ backgroundColor: "#EAEAEA" }}
                    onChange={(event) => {
                      setProposedAction(event.target.value);
                    }}
                  />
                </div>}
            </>
          ) : (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {userType == "SEBI" ? (
                  <h4 style={{ width: "30%" }}>SEBI Comments</h4>
                ) : ("")}
                <TextField
                  autoFocus
                  required
                  margin="dense"
                  id="sebiComments"
                  name="sebiComments"
                  placeholder={
                   "SEBI Comments"
                  }
                  type="text"
                  fullWidth
                  variant="outlined"
                  multiline

                  sx={{ backgroundColor: "#EAEAEA", height: "100%" }}
                  onChange={userType == "SEBI" ? (event) => {
                    setSebiComments(event.target.value);
                  } : (event) => {
                    setPmsComments(event.target.value);
                  }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {userType == "SEBI" ? (
                  <>
                    <h4 style={{ width: "30%" }}>Remarks</h4>
                    <Select
                      value={selectedActions}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            color: "#000000",
                            "& .MuiMenuItem-root": {
                              padding: 1,
                            },
                            height: "20%",
                          },
                        },
                      }}
                      sx={{
                        backgroundColor: "#EAEAEA",
                        width: "100%",
                        height: "100%",
                        overflow: "hidden"
                      }}
                      displayEmpty
                      renderValue={(selected) => {
                        if (selected.length === 0) {
                          return "Select Remarks";
                        }
                        return selected.join(", ");
                      }
                      }
                      multiple
                    >
                      <MenuItem style={{ display: "flex", justifyContent: "center", alignItems: "center" }} onClick={handleSelectAll}>
                        <Checkbox
                          checked={selectedActions.length === actionsOptions.length}
                          indeterminate={selectedActions.length > 0 && selectedActions.length < actionsOptions.length}
                        />
                        <ListItemText primary="Any action taken" />
                      </MenuItem>
                      {actionsOptions.map((name) => (
                        <MenuItem key={name.label} value={name.value} onClick={() => handleActionsChange(name.label)}>
                          <Checkbox
                            checked={selectedActions.includes(name.value)}
                          />
                          <ListItemText primary={name.label} />
                        </MenuItem>
                      ))}
                    </Select>
                  </>
                ) : (
                  ""
                )}
              </div>
            </>
          )}
        </DialogContent>
        <DialogActions sx={{ padding: "0 1.5rem 1rem 1.5rem" }}>

          {userType == "PMS" ? (
            <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
              {userType == "PMS" && moduleType == "ALERT" ? <div style={{ color: "#808080", alignSelf: "end" }}>Instance Count: {PMSTrackerPageData.instanceCount - PMSTrackerPageData.caseIdCount}</div> : <div></div>}
              <div style={{ display: "flex", gap: "1rem" }}>
                {moduleType == "ALERT" && statusPending == "pending" ? (
                  <>
                    <input
                      type="file"
                      id="uploadFile"
                      // required
                      style={{ display: "none" }}
                      onClick={event => event.target.value = null}
                      onChange={(event) => {
                        setDetails(event?.target?.files[0]);
                        setFile(event?.target?.files[0]?.name);
                      }}
                    />
                    <div id="uploadFileDelete"
                      style={{ cursor: "pointer", display: "flex", alignItems: "flex-end" }}
                    >
                      <div>
                        {file ? (
                          <TextField
                            id="outlined-basic"
                            value={file}
                            style={{ width: file === "" ? "0px" : "auto" }}
                            variant="standard"
                            inputProps={{
                              style: {
                                textAlign: "center",
                              },
                            }}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                      <div
                      >
                        {file && <DeleteForeverIcon sx={{ color: "#e6435b" }} onClick={handleFile} />}

                      </div>
                    </div>

                    {file == "" && <button
                      className={Styles.BrowseBtn}
                      onClick={() => {
                        // setFileName("");
                        document.getElementById("uploadFile").click();

                      }}
                    // required
                    >
                      Browse
                    </button>}
                  </>) : (
                  <UploadAction statusPending={statusPending} moduleType={moduleType} remarks={remarks} handleDeleteFile={handleDeleteFile} />
                )}
                <button
                  className={Styles.formSendBtn}
                  type="submit"
                  onClick={async () => {
                    setSubmit(true);
                    dispatch({ type: "setSubmitState", setSubmitState: true })
                    handleSubmit(false)
                    setOpen(false)
                  }}
                >
                  SEND
                </button>
              </div>
            </div>
          ) : (
            <>
              <UploadAction />
              <button
                className={Styles.commentBtn}
                style={{
                  color: "#ffffff",
                  marginLeft: "10px",
                  height: "1.875rem",
                  width: "8.125rem",
                  backgroundColor: "#24B500",
                  borderColor: "#24B500",
                  cursor: "pointer",
                }}
                onClick={() => {
                  handleSubmit(true)
                  setOpen(false)
                  // trackerPageFetch()
                }}

              >
                CLOSE
              </button>
              <LightTooltip title={selectedActions.length > 0 ? "Uncheck Remarks to Elaborate" : ""} placement="top">
                <span>
                  <button
                    className={Styles.commentBtn}
                    onClick={() => {
                      handleSubmit(false)
                      setOpen(false)
                      // trackerPageFetch()
                    }}
                    style={{
                      color: "#ffffff",
                      marginLeft: "10px",
                      height: "1.875rem",
                      width: "8.125rem",
                      backgroundColor: selectedActions.length > 0 ? "#808080" : "#CF3E3E",
                      borderColor: selectedActions.length > 0 ? "#808080" : "#CF3E3E",
                      cursor: "pointer",
                    }}
                    disabled={selectedActions.length > 0 ? true : false}
                  >
                    ELABORATE
                  </button>
                </span>
              </LightTooltip>
            </>
          )}
        </DialogActions>
      </Dialog>
    );
  };

  export default CommentDialogBox;